import axios from 'axios';
import cookies from 'js-cookie';
import endpoints, { pmsEndpoints, GRAPH_URL, graphqlURL } from '~settings/endpoints';
import * as queries from '~settings/pms-queries';
import * as landlordQueries from '~settings/queries';
import { cookieNames } from '~constants';

export const getGraphQlHeader = () => ({
  Authorization: cookies.get(cookieNames.token) ? `Bearer ${cookies.get(cookieNames.token)}` : '',
  'Accept-Language': 'en-us',
});

const getCurrentRoleGraphQlHeader = () => ({
  Authorization: cookies.get(cookieNames.token) ? `Bearer ${cookies.get(cookieNames.token)}` : '',
  'Accept-Language': 'en-us',
  'Current-Role': 'landlord',
});

export const checkUserExist = params =>
  axios({
    method: 'POST',
    url: pmsEndpoints.checkUserExist.url(),
    data: queries.checkUserExist(params),
    headers: getGraphQlHeader(),
  });

export const checkLandlordAccountExist = params =>
  axios({
    method: 'POST',
    url: endpoints.checkLandlordAccountExist.url(),
    data: landlordQueries.checkLandlordAccountExist(params),
    headers: getGraphQlHeader(),
  });

export const listingManagementFetch = data =>
  axios({
    method: 'POST',
    url: GRAPH_URL,
    data,
    headers: getCurrentRoleGraphQlHeader(),
  }).then(res => {
    if (res.data && !res.data.errors && res.data.data) {
      return res.data.data;
    }
    if (res.data && res.data.errors) {
      throw new Error(res.data.errors);
    }
    throw new Error('Update Failed');
  });

export const getWithdrawalMethods = params =>
  axios({
    method: 'POST',
    url: endpoints.getWithdrawalMethods.url(),
    data: landlordQueries.getWithdrawalMethods(params),
    headers: getCurrentRoleGraphQlHeader(),
  });

export const fetch = ({ url, query }) =>
  axios({
    method: 'POST',
    url: url || graphqlURL,
    data: query,
    headers: getCurrentRoleGraphQlHeader(),
  }).then(res => {
    if (res.data && !res.data.errors && res.data.data) {
      return res.data.data;
    }
    if ((res.data && res.data.errors) || res.data?.extensions?.code) {
      throw new Error(
        res.data?.extensions?.code ||
          (res.data.errors && res.data.errors[0] && res.data.errors[0].message),
      );
    }
    throw new Error('Update Failed');
  });

export const checkLandlordExist = params =>
  axios({
    method: 'POST',
    url: endpoints.checkLandlordAccountExist.url(),
    data: landlordQueries.checkLandlordExist(params),
    headers: getGraphQlHeader(),
  });
